module.exports = __webpack_public_path__ + "img/vs.883c42a1.svg";